import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import ReportIcon from '@mui/icons-material/Report';
import sty from './ChecklistModal.module.css';

function ChecklistDeleteWarning({ handler }) {
	const { onConfirm = null, onDiscard = null } = handler || {};
	return (
		<Dialog
			open={true}
			onClose={onDiscard}
			aria-labelledby="draggable-dialog-title"
		>
			<div className={sty.header_bar} />
			<section className={sty.dialog_section}>
				<ReportIcon className={sty.icon} />
				<div className={sty.dialog_title_content}>
					<DialogTitle
						className={sty.dialog_title}
						id="draggable-dialog-title"
					>
						Warning: Checklist will be removed from assigned patrols
					</DialogTitle>
					<DialogContent className={sty.dialog_content}>
						<DialogContentText>
							The checklist(s) will be removed from all patrols to
							which they have been assigned. Do you want to
							continue?
						</DialogContentText>
					</DialogContent>
				</div>
			</section>
			<Divider />
			<DialogActions className={sty.dialog_actions}>
				<Button variant="outlined" size="small" onClick={onDiscard}>
					Cancel
				</Button>
				<Button variant="contained" size="small" onClick={onConfirm}>
					Delete
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default ChecklistDeleteWarning;
